// @flow
import useOnActivity from './useOnActivity';

import usePoller from 'common/hooks/usePoller';
import useEffectOnce from 'common/hooks/useEffectOnce';
import StoredSession from 'common/services/StoredSession';

import Time from 'common/constants/time';

type IdleTimeoutOptions = {
    onIdle: (timeElapsedAfterTimeout: number) => void,
    onActivity: () => void,
    timeout: number
};

type IdleTimeout = {
    reset: () => void,
    checkIfIdle: () => void
};

const POLLING_INTERVAL = 30 * Time.sec;

const useIdleTimeout = ({
    onIdle,
    onActivity,
    timeout
}: IdleTimeoutOptions): IdleTimeout => {
    const timer = {
        checkIfIdle: () => {
            const diff = StoredSession.getSessionTimeDiffFromExpiry();
            return diff > 0;
        },
        reset: () => {
            StoredSession.setSessionExpiryTime(Date.now() + timeout);
        }
    };

    const checkAndRunOnIdle = () => {
        const isIdle = timer.checkIfIdle();
        if (isIdle) {
            const timeElapsed = StoredSession.getSessionTimeDiffFromExpiry();
            onIdle(timeElapsed);
        }
    };

    useEffectOnce(checkAndRunOnIdle);

    useOnActivity(() => {
        timer.reset();
        onActivity();
    });

    usePoller(checkAndRunOnIdle, {
        interval: POLLING_INTERVAL,
        immediate: true
    });

    return timer;
};

export default useIdleTimeout;
